import { NextDto } from './next.dto';

export class Next {
    courseId: string | null;
    moduleId: string | null;
    lessonId: string | null;

    constructor(data: NextDto | null) {
        this.courseId = data?.courseId ?? null;
        this.moduleId = data?.moduleId ?? null;
        this.lessonId = data?.lessonId ?? null;
    }
}
